<template>
    <Form>
        <h2>Create your account</h2>

        <SignupForm />
    </Form>
</template>

<script>
import Form from "@/pages/Form";
import SignupForm from "@/components/SignupForm.vue";
export default {
    components: {SignupForm, Form},
};
</script>

<style scoped>

</style>
